module.exports = __webpack_public_path__ + "img/header-weddingRingsModern@2x.88f7f3a.jpg";